import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Crumbs } from "../components/Bits";
import { Head } from "../components/Head";
import { useData } from "../lib/data";
import { SITE } from "../lib/util";

const pyCmp = (a, b) => (a < b ? -1 : a > b ? 1 : 0);

export default function RecipesIndex() {
  const { recipes, categories } = useData();
  const { search } = useLocation();
  const [q, setQ] = useState("");
  const [tag, setTag] = useState("");
  const [time, setTime] = useState("");
  const [sort, setSort] = useState("navn");
  useEffect(() => {
    const p = new URLSearchParams(search);
    if (p.get("q")) setQ(p.get("q"));
    if (p.get("tag")) setTag(p.get("tag"));
  }, [search]);

  const list = useMemo(() => [...recipes].sort((a, b) => pyCmp(a.title, b.title)), [recipes]);
  const t = q.trim().toLowerCase(), mt = +time || 0;
  const vis = r => {
    const s = (r.title + " " + r.tags.join(" ") + " " + r.ingredients.map(i => i.name).join(" ")).toLowerCase();
    return (!tag || r.tags.includes(tag)) && (!mt || r.time <= mt) && (!t || s.includes(t));
  };
  const order = {};
  [...list].sort((a, b) => sort === "pris" ? a.price - b.price : sort === "tid" ? a.time - b.time
    : a.title.toLowerCase().localeCompare(b.title.toLowerCase(), "da")).forEach((r, i) => { order[r.slug] = i; });
  const n = list.filter(vis).length;

  return (
    <>
      <Head title="Alle opskrifter" path="opskrifter/" desc={`Alle opskrifter på ${SITE}: billig aftensmad, airfryer, mealprep, vegetar og klassikere. Filtrér på tid og kategori.`} />
      <Crumbs trail={[[null, "Opskrifter"]]} />
      <div className="wrap">
        <div className="ptop"><h1>Alle opskrifter</h1><p className="lead">{recipes.length} opskrifter til hverdagen. Filtrér efter tid, kategori eller søg på en ingrediens.</p></div>
        <div className="chips" role="group" aria-label="Kategori">
          <button className="fchip" type="button" data-tag="" aria-pressed={String(tag === "")} onClick={() => setTag("")} data-testid="filter-chip-alle">Alle</button>
          {categories.map(c => (
            <button key={c.key} className="fchip" type="button" data-tag={c.tag} aria-pressed={String(tag === c.tag)} onClick={() => setTag(c.tag)} data-testid={`filter-chip-${c.key}`}>{c.name}</button>
          ))}
        </div>
        <div className="filters">
          <label className="vh" htmlFor="fq">Søg</label>
          <input id="fq" type="search" placeholder="Søg fx kylling, pasta eller airfryer" value={q} onChange={e => setQ(e.target.value)} data-testid="recipes-filter-search" />
          <label className="vh" htmlFor="ftime">Maksimal tid</label>
          <select id="ftime" value={time} onChange={e => setTime(e.target.value)} data-testid="recipes-filter-time">
            <option value="">Alle tider</option><option value="25">Højst 25 min</option><option value="40">Højst 40 min</option><option value="60">Højst 60 min</option>
          </select>
          <label className="vh" htmlFor="fsort">Sortér</label>
          <select id="fsort" value={sort} onChange={e => setSort(e.target.value)} data-testid="recipes-filter-sort">
            <option value="navn">Sortér: A til Å</option><option value="pris">Sortér: billigste først</option><option value="tid">Sortér: hurtigste først</option>
          </select>
        </div>
        <p className="count" id="fcount" aria-live="polite" data-testid="recipes-count">{n + (n === 1 ? " opskrift" : " opskrifter")}</p>
        <div id="rlist"><div className="grid">{list.map(r => <Card key={r.slug} r={r} hidden={!vis(r)} style={{ order: order[r.slug] }} />)}</div></div>
        <div className="none" id="fnone" hidden={n > 0} data-testid="recipes-none"><h3>Ingen opskrifter matcher</h3><p>Prøv en anden søgning, eller fjern et filter.</p></div>
      </div>
    </>
  );
}
